export default {
  methods: {
    toggleViewCondition(criteria) {
      return this.$store.getters.toggleViewCondition(criteria);
    },
  },
};
